module.exports = __webpack_public_path__ + "img/PF.0e42e261.svg";